export const DBOperation = ["INSERT", "UPDATE", "DELETE"] as const;
